import React, { useState } from 'react';
import { I18n } from 'aws-amplify';
import { createMuiTheme } from '@material-ui/core/styles';
import LapDialog from '../../util/laplaceDialog.js';

function DefaultPatternSelector(props) {
  const [isAlertUpdateDefault, setIsAlertUpdateDefault] = useState(false);
  const [selectedDefaultPatternId, setSelectedDefaultPatternId] = useState(0);
  const updateDefault = async(e) => {
    const {value} = e.target;
    setSelectedDefaultPatternId(Number(value));
    // ダイアログを表示
    setIsAlertUpdateDefault(true);
  }

  let nowDefault;
  for (let i = 0; i < props.viewPatterns.length; i++) {
    if (props.viewPatterns[i].isDefault) {
      nowDefault = props.viewPatterns[i].id;
      break;
    }
  }
  const updateDefaultPattern = () => {
    setIsAlertUpdateDefault(false);
    props.putDefaultPattern(selectedDefaultPatternId);
  }
  return(
    <>
      <div className="defaultPatternSelector">
        <p>{I18n.get('Pattern of Default Settings')}</p>
        <div className="ppaAssetSelector">
          <select name="pattern" value={nowDefault} onChange={(e) =>updateDefault(e)}>
            {props.viewPatterns.map((viewPattern, i) => {
              const keyStr = `viewPatternOption${i}`;
              return(
                <option key={keyStr} value={viewPattern.id}>
                  {viewPattern.patternName}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <LapDialog
        title={''}
        contentElem={
          <div>
            <p>{I18n.get('Do you want to change this pattern to the default pattern?')}</p>
            <p>{I18n.get('It will be applied from the power plants that will be added in the next')}</p>
          </div>
        }
        theme={theme}
        firstButtonText={I18n.get('Cancel')}
        firstButtonFunc={() => setIsAlertUpdateDefault(false)}
        secondButtonText={I18n.get('Change')}
        secondButtonFunc={() => updateDefaultPattern()}
        open={isAlertUpdateDefault}
        toClose={() => {return}}
      />
    </>
  );
}
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#d6d6d6',
      dark: '#a5a5a5',
      contrastText: '#666666',
    },
    secondary: {
      main: '#9ebefd',
      contrastText: '#1a66ff',
    },
  },
});
export default DefaultPatternSelector;
